/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Empty_BodyInputs */

const en_blog_empty_body = /** @type {(inputs: Blog_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our coaches are writing about training, food and recovery. Create a free account and read them first.`)
};

const pl_blog_empty_body = /** @type {(inputs: Blog_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasi trenerzy piszą o treningu, jedzeniu i regeneracji. Załóż darmowe konto i przeczytaj je jako pierwszy.`)
};

/**
* | output |
* | --- |
* | "Our coaches are writing about training, food and recovery. Create a free account and read them first." |
*
* @param {Blog_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_empty_body = /** @type {((inputs?: Blog_Empty_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Empty_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_empty_body(inputs)
	return en_blog_empty_body(inputs)
});